export const ENCRYPTION_KEY =
  "jger8reterfgr7rtrthi90xoe827eudm23ey23gygbnrgoeyfw8e7tr37fbiufwte2tdlkwru0wurtbigtrerhshshs";
